<template>
  <el-dialog title="用户详情" width="80%" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-tabs v-model="activeKey" tab-position="left" style="height: 570px">
      <el-tab-pane v-for="(item, index) in detailTabs" :key="index" :name="item.name" :label="item.title">
        <component :is="getTabComponent(item.name)" :member-id="memberId" />
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MemberDetail',
  components: {
    UserFund: () => import('./components/user-fund'),
    UserDetail: () => import('./components/user-detail'),
    UserAssets: () => import('./components/user-assets'),
    UserOrder: () => import('./components/user-order'),
    UserFriend: () => import('./components/user-friend')
  },
  props: {
    show: Boolean,
    memberId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      detailTabs: [
        { name: 'basic', title: '基本信息', component: 'UserDetail' },
        { name: 'assets', title: '用户资产', component: 'UserAssets' },
        { name: 'detail', title: '资产详情', component: 'UserFund' },
        { name: 'order', title: '消费记录', component: 'UserOrder' },
        { name: 'friend', title: '好友关系', component: 'UserFriend' }
      ],
      activeKey: 'basic',
      dialogVisible: false
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  methods: {
    getTabComponent(tabName) {
      const activeTab = this.detailTabs.find(item => item.name === tabName)
      return activeTab.component
    },
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__item:hover {
      background-color: #e8f4ff;
    }
  }
</style>
